import { useCallback } from "react";
import { toast } from "react-hot-toast";

import { useV3DownloadSignedCopy } from "src/api/snugtotal/estate_app";
import { downloadFileFromS3 } from "src/utils/snug";

/**
 * Downloads a DocumentV2's signed copy. Fetches a fresh presigned URL from the
 * backend (the stored signed_file_location is durable, not presigned), then
 * triggers a browser download. Shared by the express checklist, the document
 * index menus, and the preview dialog.
 */
export const useDownloadSignedCopy = () => {
  const downloadSignedCopy = useV3DownloadSignedCopy();

  return useCallback(
    async (ud_id: string, document_id: string, fileName?: string) => {
      if (!ud_id || !document_id) {
        toast.error("No signed copy available for download");
        return;
      }
      try {
        toast.success("Downloading signed copy...");
        const url = await downloadSignedCopy(ud_id, document_id);
        if (!url) {
          throw new Error("No signed copy URL returned");
        }
        await downloadFileFromS3(url, fileName || "Signed_Copy.pdf");
      } catch (error) {
        toast.error("Failed to download signed copy");
        console.error("Download signed copy error:", error);
      }
    },
    [downloadSignedCopy]
  );
};
